import Page from "../components/Page";
import { Button, Grid } from "semantic-ui-react";
import { Link } from "react-router-dom";
import React from "react";
import { HOME_PAGE_ROUTE } from "../../api/routeConstants";

export default function PageNotFound() {
  return (
    <Page title="Page Not Found | Hello Radius">
      <Grid container textAlign="left" centered>
        <Grid.Column computer={10} tablet={15} mobile={15}>
          <div style={{ marginTop: 110 }}>
            <div className="title-normal">
              We're sorry, the page you were looking for can't be found.
            </div>
            <div
              className="body-blue-text"
              style={{ margin: "37px 0", width: "85%" }}
            >
              This might have been caused by some maintenance we're doing and
              the page will be back soon. Or the link might be broken or
              outdated.
            </div>
          </div>
          <Button
            className="overwrite-button cta-orange"
            content={"Back to homepage"}
            as={Link}
            to={HOME_PAGE_ROUTE}
          />
        </Grid.Column>
      </Grid>
    </Page>
  );
}
